export const Video = ({ videoUrl }) => {
  return (
    <div className="container flex flex-col px-4 mx-auto md:w-9/12 ">
      <div id="responsiveVideoWrapper" className="aspect-w-16 aspect-h-9">
        <div className="aspect-w-16 aspect-h-9">
          <iframe
            src={videoUrl}
            width="640"
            height="360"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>  
      </div>
    </div>
  )
}